// @ts-nocheck
import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useAppSelector, useAppDispatch } from "../hooks/useRedux";
import { likePost } from "../store/postsSlice";
import PostItem from "../components/PostItem";
import PostListLoader from "../components/PostListLoader";
import { ThemeContext } from "../Provider/ThemeProvider";
import { themes } from "../Utils/Colors";

const PostPreview = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { currentPost, posts } = state || {};
  const [playing, setPlaying] = useState(null);
  const [loading, setLoading] = useState(false);
  const clickedPostRef = useRef(null);
  const postList =
    currentPost && posts
      ? [
          currentPost,
          ...posts.filter((post) => post.post_id !== currentPost.post_id),
        ].map((post) => ({
          ...post,
          liked: post.liked,
        }))
      : [];

  useEffect(() => {
    if (clickedPostRef.current) {
      clickedPostRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  const toggleLike = (id) => {
    dispatch(likePost(id));
    setPostList((prevPosts) =>
      prevPosts.map((post) =>
        post.post_id === id
          ? {
              ...post,
              liked: !post.liked,
              like_count: post.liked
                ? post.like_count - 1
                : post.like_count + 1,
            }
          : post
      )
    );
  };

  const [postListState, setPostList] = useState(postList);

  if (!currentPost || !posts) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <p className="text-gray-400 text-lg">No post data available</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen h-[100dvh] bg-black text-white flex justify-center">
      <div className="w-full max-w-2xl p-4">
        {/* Custom Header */}
        <div className="flex items-center justify-between py-3 px-2 bg-transparent">
          <button
            onClick={() => navigate(-1)}
            className="w-10 flex justify-start items-center"
            aria-label="Go back"
          >
            <ChevronLeft size={24} className="text-white" />
          </button>
          <div className="flex-1 text-center">
            <h1 className="text-lg font-semibold text-white">
              {currentPost?.username || "User"}
            </h1>
          </div>
          <div className="w-10" />
        </div>

        {/* Post List */}
        {loading ? (
          <PostListLoader />
        ) : (
          <div className="py-2 px-4 max-w-2xl mx-auto space-y-4">
            {postListState.length === 0 ? (
              <div className="flex items-center justify-center mt-12">
                <p className="text-gray-400 text-lg">No posts yet.</p>
              </div>
            ) : (
              postListState.map((item, index) => (
                <div
                  key={item.post_id?.toString() || item.id?.toString()}
                  ref={index === 0 ? clickedPostRef : null}
                >
                  <PostItem
                    item={item}
                    onToggleLike={toggleLike}
                    playing={playing}
                    setPlaying={setPlaying}
                    fromPostPreview={true}
                  />
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PostPreview;
